import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "footer-pc"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = ["href"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1);
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "copyright"
}, "Copyright © 尊龙凯时独家赞助 All Rights Reserved.", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_image_cdn = _resolveComponent("image-cdn");
  const _component_van_row = _resolveComponent("van-row");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_col = _resolveComponent("van-col");
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_row, {
    class: "logos",
    justify: "space-between",
    align: "center"
  }, {
    default: _withCtx(() => [_createElementVNode("a", {
      href: _ctx.$filters.promoteUrl('/')
    }, [_createVNode(_component_image_cdn, {
      src: require('@/assets/images/pc/footer-du-logo.png'),
      alt: ""
    }, null, 8, ["src"])], 8, _hoisted_3), _hoisted_4, _createElementVNode("a", {
      href: _ctx.$filters.promoteUrl('/member.php?mod=togw')
    }, [_createVNode(_component_image_cdn, {
      src: require('@/assets/images/pc/footer-zl-logo.png'),
      alt: ""
    }, null, 8, ["src"])], 8, _hoisted_5)]),
    _: 1
  }), _createVNode(_component_van_row, {
    class: "links",
    justify: "space-between",
    align: "center"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: '/others/rule'
      }, {
        default: _withCtx(() => [_createTextVNode("社区规则")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_col, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: '/others/privacy'
      }, {
        default: _withCtx(() => [_createTextVNode("隐私说明")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_col, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: '/others/aboutus'
      }, {
        default: _withCtx(() => [_createTextVNode("关于我们")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_van_col, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: '/others/appdownload'
      }, {
        default: _withCtx(() => [_createTextVNode("APP下载")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]), _hoisted_6]);
}